import { Toaster } from "sonner"
import { Footer } from "./components/footer/footer"
import { Header } from "./components/header/header"
import { BottomNavigation } from "./components/common/BottomNavigation"
import { Outlet, useLocation } from "react-router";
import { FloatingContactButton } from "./components/common/FloatingContactButton"
import { cn } from "./lib/utils"

/**
 * Layout chính của ứng dụng, bao gồm Header, nội dung và Footer
 */
function App() {
  const { pathname } = useLocation()
  const usesOverlayHeader = pathname === "/" || pathname.startsWith("/thu-vien-anh")

  return (
    <>
      <div className="flex min-h-screen flex-col">
        <Header />

        <main
          className={cn(
            "relative flex-1 bg-background pb-16 lg:pb-0",
            !usesOverlayHeader && "pt-16 lg:pt-[72px]",
          )}
        >
          <Outlet />
        </main>

        <Footer />
      </div>

      <BottomNavigation />
      <FloatingContactButton />
      <Toaster richColors position="top-center" />
    </>
  )
}

export default App
